const { upgradeArray } = require('../utils')

const SETTINGS_SCHEMA_TYPE = upgradeArray([ 'user', 'site' ])

module.exports = {
  SETTINGS_SCHEMA_TYPE
}
